import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';

export type SegmentedOption =
  | {
      label: string;
      value: string | number;
      icon?: string;
      disabled?: boolean;
    }
  | string
  | number;

@Component({
  selector: 'ui-segmented',
  templateUrl: './segmented.component.html',
  styleUrl: './segmented.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [FormsModule, NzSegmentedModule],
})
export class UISegmented {
  @Input() value?: number | string;
  @Input() disabled = false;
  @Input() block = true;
  @Input({ required: true }) options: SegmentedOption[] = [];

  @Output() valueChange = new EventEmitter<number | string>();

  handleValueChange(value: number | string): void {
    this.value = value;
    this.valueChange.emit(this.value);
  }
}
